const scrollToElement = (id) => {
  const el = document.getElementById(id);
  // el.style.border = '5px solid limegreen';
  const headerBuffer = 200;
  const y = el.getBoundingClientRect().top + window.scrollY - headerBuffer;
  window.scroll({
    top: y,
    behavior: 'smooth',
  });

  // Move focus to the scroll location
  setTimeout(() => {
    el.focus();
    // If focus didn't work, add a tabindex and focus that
    if (document.activeElement !== el) {
      el.tabindex = -1;
      el.focus();
    }
  }, 1000);
}

export default scrollToElement;